/* eslint-disable no-param-reassign */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/sort-comp */
/* eslint-disable react/prop-types */
import {useState, useEffect, useRef} from 'react';
import Util from '../util/Util';
import Locale from '../util/Locale';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import TagView from './TagView';
import GridView from './GridView';
import Modal from '../components/Modal';
import Badge from '../components/Badge';
import Pagination from '../components/Pagination';
import Detail from './Detail';
import './MediaLibraryView.scss';
import FolderView from './FolderView';
import Tabs from '../components/Tabs';
import MarsUpload from '../components/MarsUpload';
import Analytics from '../util/Analytics';
import {hasAccess} from '../util/userInfo';
import {useNavTree} from '../Providers/NavTreeProvider';
import renderMaintenanceCleanupModal from '../components/MaintenanceCleanupModal';

export function isBridgeBarAvailable() {
    return Boolean(document.querySelector('bridge-bar'));
}
let timeoutId;

export default function MediaLibraryView({
    viewData,
    controllerApi,
    totalAssets,
    page,
    size,
    onDeleteAssetList,
    onEditAsset,
    onSelect,
    onAction,
    onDragAsset,
    setMovementSrc,
    setPage,
    setPageSize,
    getSelectedPathForUploads,
    assetFilters,
    tabIdx,
    tags,
    tagSelected,
    onTabSelect,
    onTagClick,
    focused,
    isDraggingAsset,
    movementSrc,
    contextError,
    loading,
    pageSize,
    maxPages,
    previousEnabled,
    nextEnabled,
    updateStatePrevAndNext,
    checkForPrevAndNext,
    onCreateFolder,
    onDeleteSelectedFolder,
    onFolderAction,
    onMoveAssetList,
    onRenameSelectedFolder,
    setDraggingAsset,
    selections,
    assetTags,
    onDeleteTag,
    onAddTag,
    onNextAsset,
    onPreviousAsset,
    maintenance,
    pageDispatch
}) {
    const [showFileTree, setShowFileTree] = useState(false);
    const [isSplitScreen, setIsSplitScreen] = useState(Util.isSplitScreen());
    const [prevViewData, setPrevViewData] = useState(null);
    const [listData, setListData] = useState('');
    const [hoverIdx, setHoverIdx] = useState(-1);
    const [topPos, setTopPos] = useState(0);
    const [leftPos, setLeftPos] = useState(0);
    const tableRef = useRef();
    const {navtree} = useNavTree();
    const {folderData, location, folderName, selectedNode} = navtree;

    const onResize = () => {
        setIsSplitScreen(Util.isSplitScreen());
    };

    useEffect(() => {
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, []);

    useEffect(() => {
        if (viewData !== prevViewData) {
            const lData = viewData && viewData.length ? JSON.stringify(MediaLibraryView.dataForListView(viewData)) : '';
            setPrevViewData(viewData);
            setListData(lData);
        }
    }, [viewData, prevViewData]);

    useEffect(() => {
        if (maintenance && maintenance.status !== 'idle') {
            const {setShowModal, doMaintenanceCleanup} = controllerApi || {};
            renderMaintenanceCleanupModal(maintenance, setShowModal, doMaintenanceCleanup);
        }
    }, [maintenance]); // eslint-disable-line react-hooks/exhaustive-deps

    const toggleSidebar = () => {
        setShowFileTree(!showFileTree);
    };

    const closeBadge = () => {
        if (controllerApi.setFilterSelect) {
            controllerApi.setFilterSelect('all');
        }
    };

    const clearDateRange = () => {
        if (controllerApi.setDateRange) {
            controllerApi.setDateRange(null, null);
        }
    };

    const formatBadgeDate = ms => {
        const date = new Date(ms);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${month}/${day}/${date.getFullYear()}`;
    };

    const getDateRangeBadgeText = () => {
        const {dateFrom, dateTo} = controllerApi.getDateRange
            ? controllerApi.getDateRange()
            : {dateFrom: null, dateTo: null};
        if (dateFrom === null && dateTo === null) {
            return '';
        }
        const from = dateFrom !== null ? formatBadgeDate(dateFrom) : '…';
        const to = dateTo !== null ? formatBadgeDate(dateTo) : '…';
        return `${Locale.getText('DATE_RANGE_BADGE')} ${from} – ${to}`;
    };

    const getSelectedTagName = isTagView => {
        return isTagView && tags && tagSelected > -1 ? `: ${tags[tagSelected]}` : '';
    };

    const getHeader = (isTagView = false) => {
        const tagName = getSelectedTagName(isTagView);
        return (
            <Header
                controllerApi={controllerApi}
                filterSelect={controllerApi.getFilterSelect()}
                focused={focused}
                isTagView={isTagView}
                folderName={isTagView ? `${Locale.getText('TAG')}${tagName}` : folderName}
                location={isTagView ? `${Locale.getText('TAG')}${tagName}` : location}
                getAssetList={controllerApi.getAssetList}
                getLocked={controllerApi.getLocked}
                getShowModal={controllerApi.getShowModal}
                getSortValue={controllerApi.getInternalSortBy}
                getDateRange={controllerApi.getDateRange}
                gridView={controllerApi.getShowGrid()}
                isDraggingAsset={isDraggingAsset}
                movementSrc={movementSrc}
                onDeleteAssetList={isTagView ? null : onDeleteAssetList}
                onEditAsset={onEditAsset}
                onFilterSelect={controllerApi.setFilterSelect}
                onMenuChange={controllerApi.setShowMenu}
                onSearchQueryChange={controllerApi.setSearchQuery}
                onSortChange={controllerApi.setInternalSortBy}
                onDateRangeChange={controllerApi.setDateRange}
                getSelectedPathForUploads={isTagView ? null : getSelectedPathForUploads}
                onViewChange={controllerApi.setShowGrid}
                selections={selections}
                setMovementSrc={setMovementSrc}
                setShowFocused={controllerApi.setShowFocused}
                setShowModal={controllerApi.setShowModal}
                toggleSidebar={toggleSidebar}
                viewData={viewData}
                assetFilters={assetFilters}
                totalAssets={totalAssets}
                page={page}
                size={size}
            />
        );
    };

    const renderModal = () => {
        const modal = controllerApi.getShowModal();
        if (modal) {
            return (
                <Modal
                    className={`${modal.className || ''}${isBridgeBarAvailable() ? ' bridge-bar' : ''}`}
                    title={modal.title}
                >
                    {modal.content}
                </Modal>
            );
        }
        return null;
    };

    const getSortedByString = () => {
        const sortBy = controllerApi.getInternalSortBy();
        if (sortBy) {
            const sortStr = Util.sortByMap()[sortBy];
            if (sortStr) {
                return `${Locale.getText('SORTED_BY')} ${sortStr}`;
            }
        }
        return '';
    };

    const renderTotalAssetsRow = () => {
        const sortBy = getSortedByString();
        const total = totalAssets ? `${Locale.getText('ASSETS_TOTAL', {total: totalAssets})} ${sortBy}` : '';
        const badgeMappings = {
            images: 'IMAGES_ONLY',
            videos: 'VIDEOS_ONLY',
            documents: 'DOCUMENTS_ONLY',
            '4:1': '4TO1',
            '4:3': '4TO3',
            '10:1': '10TO1',
            '9:16': '9TO16'
        };
        const badge = MediaLibraryView.allowBadge(assetFilters)
            ? badgeMappings[controllerApi.getFilterSelect()]
            : false;
        const dateBadgeText = getDateRangeBadgeText();
        return (
            <div className="total-assets-row">
                {total.length > 0 && <h4>{total}</h4>}
                {badge && <Badge text={Locale.getText(badge)} onAction={closeBadge} />}
                {dateBadgeText && <Badge text={dateBadgeText} onAction={clearDateRange} />}
                {!loading &&
                    maintenance &&
                    viewData?.length > 0 &&
                    controllerApi.getLocked &&
                    !controllerApi.getLocked() && (
                        <nsemble-button
                            key="CLEANUP"
                            destructive-text
                            onClick={() => {
                                pageDispatch({type: 'START_MAINTENANCE_CLEANUP'});
                            }}
                        >
                            Cleanup
                        </nsemble-button>
                    )}
            </div>
        );
    };

    const defaultNoDataContent = (isTagView, unselectedTagView) => {
        if (unselectedTagView) {
            return <div className="empty-message">{Locale.getText('NO_TAG_SELECTED')}</div>;
        }
        const isSearchFilter = controllerApi.getSearchQuery() || controllerApi.getFilterSelect() !== 'all';
        if (isSearchFilter) {
            return <div className="empty-message">{Locale.getText('NO_RESULTS_FOUND')}</div>;
        }
        if (isTagView) {
            return <div className="empty-message">{Locale.getText('NO_ASSETS_FOUND')}</div>;
        }
        return <div className="empty-message">{Locale.getText('EMPTY_FOLDER')}</div>;
    };

    const getSortControlDirections = () => {
        const sortBy = controllerApi.getInternalSortBy();
        const results = [];
        if (sortBy === 'nameAsc') {
            results.push('asc');
        } else if (sortBy === 'nameDes') {
            results.push('des');
        } else {
            results.push('');
        }
        if (sortBy === 'type') {
            results.push('asc');
        } else {
            results.push('');
        }
        if (sortBy === 'sizeAsc') {
            results.push('asc');
        } else if (sortBy === 'sizeDes') {
            results.push('des');
        } else {
            results.push('');
        }
        return results;
    };

    const reduceList = data => {
        const list = JSON.parse(data);
        const dimensions = [];
        for (let i = 0; i < list.length; i += 1) {
            dimensions.push(list[i].splice(2, 1));
        }
        const results = {
            listItems: JSON.stringify(list),
            dimensions
        };
        return results;
    };

    const listColConfig = (isWidget, sortDirection) => {
        const colDimensions = [
            {
                label: Locale.getText('NAME'),
                type: 'string',
                width: isWidget ? '60%' : '60%',
                sort: sortDirection[0]
            },
            {
                label: Locale.getText('TYPE'),
                type: 'string',
                width: isWidget ? '20%' : '10%',
                sort: sortDirection[1]
            },
            ...(!isWidget ? [{label: Locale.getText('DIMENSIONS'), type: 'string', width: '15%'}] : []),
            {
                label: isWidget ? Locale.getText('SIZE') : Locale.getText('FILE_SIZE'),
                type: 'number',
                width: isWidget ? '20%' : '15%',
                sort: sortDirection[2]
            }
        ];
        return JSON.stringify(colDimensions);
    };

    const stripMeatballIcons = data => {
        if (!data) {
            return data;
        }
        const node = {...data};
        if ('icons' in data && data.icons.length === 1 && data.icons[0] === 0) {
            delete node.icons;
        }
        if (data.children) {
            node.children = [];
            for (let i = 0; i < data.children.length; i += 1) {
                node.children.push(stripMeatballIcons(data.children[i]));
            }
        }
        return node;
    };

    const getSideBar = status => {
        const data = isSplitScreen ? stripMeatballIcons(folderData) : folderData;
        const hasSelections = selections && selections?.some(selection => selection === true);
        const isAdvertisingRoot = controllerApi && controllerApi.isAdvertisingRoot();

        return (
            <Sidebar showing={status}>
                <Tabs
                    titles={[{title: Locale.getText('MEDIA')}, {title: Locale.getText('TAGS')}]}
                    onSelect={onTabSelect}
                >
                    <FolderView
                        allowExternalWebElements={hasSelections && !isAdvertisingRoot}
                        data={data}
                        folderName={folderName}
                        selectedNode={selectedNode}
                        controllerApi={controllerApi}
                        contextError={contextError}
                        getAssetList={controllerApi.getAssetList}
                        isDraggingAsset={isDraggingAsset}
                        location={location}
                        movementSrc={movementSrc}
                        onCreateFolder={onCreateFolder}
                        onDeleteSelectedFolder={onDeleteSelectedFolder}
                        onFolderAction={onFolderAction}
                        onMoveAssetList={onMoveAssetList}
                        onRenameSelectedFolder={onRenameSelectedFolder}
                        setMovementSrc={setMovementSrc}
                        setShowModal={controllerApi.setShowModal}
                        setDraggingAsset={setDraggingAsset}
                        getShowModal={controllerApi.getShowModal}
                        toggleSidebar={toggleSidebar}
                    />
                    <TagView
                        showing={status}
                        tags={tags || []}
                        selected={tagSelected === undefined ? -1 : tagSelected}
                        toggleSidebar={toggleSidebar}
                        onClick={onTagClick}
                    />
                </Tabs>
            </Sidebar>
        );
    };

    const renderLoadingIcon = () => {
        return (
            <div className="outer-page-loading">
                <div className="page-loading" />
            </div>
        );
    };

    const renderContextError = () => {
        const errorLabel = contextError?.context?.includes('navtree') ? 'FOLDER_LOADING_ERROR' : 'ASSETS_LOADING_ERROR';
        return (
            <div className="network-error">
                <div className="network-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="48px" height="48px">
                        <path d="M0 0h24v24H0V0z" fill="none" />
                        <path d="M18 7V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3c-.55 0-1 .45-1 1v4.7c0 .2.06.39.17.55L8 19v2c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2l2.83-5.75c.11-.16.17-.36.17-.55V8c0-.55-.45-1-1-1zm-2 0h-2V5.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5V7h-2V5.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5V7H8V4h8v3z" />
                    </svg>
                    <div>
                        {Locale.getText(errorLabel)} {Locale.getText('NETWORK_ERROR')}
                    </div>
                </div>
            </div>
        );
    };

    const renderView = (viewContent, isTagView) => {
        return (
            <div className="outer-view">
                {getSideBar(showFileTree)}
                <div className={showFileTree && !Util.isWidget() ? 'list-container list-hidden' : 'list-container'}>
                    {getHeader(isTagView)}
                    <div className={`scrollView ${loading ? 'full-height' : ''}`}>
                        {!contextError && renderTotalAssetsRow()}
                        {viewContent}
                    </div>
                    {!loading && (
                        <Pagination
                            maxPages={maxPages}
                            totalAssets={totalAssets}
                            pageSize={pageSize}
                            page={page}
                            setPage={setPage}
                            setPageSize={setPageSize}
                        />
                    )}
                </div>
                {renderModal()}
            </div>
        );
    };

    const renderDetails = isTagView => {
        const onDelAssetList =
            !isTagView && controllerApi.getLocked && !controllerApi.getLocked() && onDeleteAssetList
                ? onDeleteAssetList
                : null;
        return (
            <div className="outer-view">
                {getSideBar(showFileTree)}
                <div className={showFileTree && !Util.isWidget() ? 'list-container list-hidden' : 'list-container'}>
                    {getHeader()}
                    {renderModal()}
                    <Detail
                        renderLoadingIcon={renderLoadingIcon}
                        setShowFocused={controllerApi.setShowFocused}
                        focused={focused}
                        setShowModal={controllerApi.setShowModal}
                        onDeleteAssetList={onDelAssetList}
                        isTagView={isTagView}
                        getSelectedPathForUploads={getSelectedPathForUploads}
                        controllerApi={controllerApi}
                        getLocked={controllerApi.getLocked}
                        tags={assetTags}
                        onDeleteTag={onDeleteTag}
                        onAddTag={onAddTag}
                        onNextAsset={onNextAsset}
                        onPreviousAsset={onPreviousAsset}
                        previousEnabled={previousEnabled}
                        nextEnabled={nextEnabled}
                        updateStatePrevAndNext={updateStatePrevAndNext}
                        checkForPrevAndNext={checkForPrevAndNext}
                        page={page}
                        maxPages={maxPages}
                        viewData={viewData}
                        onAction={onAction}
                    />
                </div>
            </div>
        );
    };

    const renderListView = (isTagView, unselectedTagView) => {
        const isWidget = Util.isWidget();
        const sortDirection = getSortControlDirections();
        const config = listColConfig(isWidget, sortDirection);
        let viewContent = defaultNoDataContent(isTagView, unselectedTagView);
        const extendPopupTime = () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                setHoverIdx(-1);
            }, 2000);
        };

        const onHover = (listIdx, rowEl) => {
            if (!Number.isNaN(listIdx) && listIdx >= 0) {
                const rowPos = rowEl.getBoundingClientRect();
                if (hoverIdx !== listIdx) {
                    setHoverIdx(listIdx);
                    setTopPos(rowPos.top + 11);
                    setLeftPos(rowPos.width / 2 + 300);
                    extendPopupTime();
                }
                extendPopupTime();
            }
        };

        if (loading) {
            viewContent = renderLoadingIcon();
        } else if (contextError && contextError.context.includes('assets')) {
            viewContent = renderContextError();
        } else if (listData && listData.length) {
            const widgetList = reduceList(listData);
            const widgetHoverStyle = {top: `${topPos}px`, left: `${leftPos}px`};
            viewContent = (
                <>
                    {hoverIdx !== -1 && (
                        <div className="widgetHover" style={widgetHoverStyle}>
                            <p className="hoverText">{`${widgetList.dimensions[hoverIdx]}px`}</p>
                        </div>
                    )}
                    <nsemble-table
                        ref={tableRef}
                        name="table"
                        columns={config}
                        rows={isWidget ? widgetList.listItems : listData}
                        selections={!isTagView && selections ? JSON.stringify(selections) : undefined}
                        onInput={onSelect}
                        onClick={onAction}
                    />
                </>
            );

            if (isWidget) {
                setTimeout(() => {
                    if (tableRef.current) {
                        const rows = tableRef.current.shadowRoot.querySelectorAll('.table-row');
                        rows.forEach(row => {
                            row.onmouseover = e => {
                                onHover(parseInt(e.currentTarget.getAttribute('data-row'), 10), e.currentTarget);
                            };
                        });
                    }
                }, 0);
            }
        }
        return renderView(viewContent, isTagView);
    };

    const renderGridView = (isTagView, unselectedTagView) => {
        let viewContent = defaultNoDataContent(isTagView, unselectedTagView);

        if (loading) {
            viewContent = renderLoadingIcon(); // displays loading icon for only the view section
        } else if (contextError && contextError.context.includes('assets')) {
            viewContent = renderContextError();
        } else if (viewData && viewData.length) {
            viewContent = (
                <div>
                    <GridView
                        isAdvertising={controllerApi.isAdvertisingRoot()}
                        selections={isTagView ? undefined : selections}
                        onInput={onSelect}
                        data={viewData}
                        onSelect={onSelect}
                        onAction={onAction}
                        onDragAsset={onDragAsset}
                    />
                </div>
            );
        }
        return renderView(viewContent, isTagView);
    };
    /* 

    const doMaintenanceCleanup = assets => {
        controllerApi?.doMaintenanceCleanup && controllerApi.doMaintenanceCleanup(assets);
    };

    const renderMaintenanceCleanupModal = () => {
        let content = null;
        if (maintenance.status === 'collecting') {
            content = <p>Finding duplicate and non-existent assets...</p>;
        } else if (maintenance.status === 'ready') {
            if (maintenance.assets.length === 0) {
                content = <p>No duplicate or non-existent assets found for cleanup.</p>;
            } else {
                content = <p>{`${maintenance.assets.length} assets marked for cleanup. Proceed with cleanup?`}</p>;
            }
        } else if (maintenance.status === 'deleting') {
            content = <p>Deleting selected assets...</p>;
        } else if (maintenance.status === 'completed') {
            content = <p>Cleanup completed with {maintenance.failures.length} failures.</p>;
        }
        controllerApi.setShowModal({
            title: 'Cleanup duplicate/non-existent assets',
            className: 'maintenance-modal',
            content: (
                <>
                    <div className="content">{content}</div>
                    <div className="add-footer">
                        <nsemble-button
                            key="YES"
                            destructive-text
                            onClick={() => doMaintenanceCleanup(maintenance.assets)}
                            disabled={
                                maintenance.status !== 'ready' || maintenance.assets.length === 0 ? true : undefined
                            }
                        >
                            {Locale.getText('DELETE_FILES')}
                        </nsemble-button>
                        <nsemble-button
                            key="CLOSE"
                            text
                            onClick={() => controllerApi?.setShowModal && controllerApi.setShowModal(false)}
                        >
                            {Locale.getText('CLOSE')}
                        </nsemble-button>
                    </div>
                </>
            )
        });
    };
 */

    const onDragEvent = event => {
        event.preventDefault();
        event.stopPropagation();
    };

    const renderWithContext = contents => {
        return (
            <div
                className={`ml3-frame${Util.isWidget() ? ' widget' : ''}${isBridgeBarAvailable() ? ' bridge-bar' : ''}`}
                onDragOver={onDragEvent}
                onDragEnter={onDragEvent}
                onDrop={e => {
                    onDragEvent(e);

                    let files = 'dataTransfer' in e ? e.dataTransfer.files : e.currentTarget.files;
                    files = Array.from(files);

                    if (!files.length) {
                        return; // prevents dragging and dropping inside the window from triggering anything
                    }

                    if (tabIdx === Util.TAB_TYPE.TAGS || controllerApi.getLocked() || focused) {
                        let dragAndDropFailureMessage =
                            tabIdx === Util.TAB_TYPE.TAGS ? 'NO_TAGS_VIEW_UPLOAD' : 'NO_LOCKED_FOLDER_UPLOAD';
                        if (focused) {
                            dragAndDropFailureMessage = 'NO_DETAILS_UPLOAD';
                        }
                        controllerApi.setShowModal({
                            title: '',
                            className: 'automodal',
                            content: <div>{Locale.getText(dragAndDropFailureMessage)}</div>
                        });
                        setTimeout(() => {
                            controllerApi.setShowModal(false);
                        }, 2000);
                        return; // cannot upload in tag view or locked folder
                    }
                    Analytics.trackEvent('Asset', 'Upload (View drop)');

                    controllerApi.setShowModal({
                        content: (
                            <MarsUpload
                                dropFiles={files}
                                title={Locale.getText('UPLOAD')}
                                setShowUpload={controllerApi.setShowModal}
                                getSelectedPathForUploads={getSelectedPathForUploads}
                                advertising={controllerApi.isAdvertisingRoot()}
                                setShowFocused={controllerApi.setShowFocused}
                                // eslint-disable-next-line react/jsx-boolean-value
                                hideDetailView={true}
                            />
                        )
                    });
                }}
            >
                {contents}
            </div>
        );
    };

    const isTagView = tabIdx === 1;
    const unselectedTagView = isTagView && tagSelected === -1;
    if (!hasAccess()) {
        return (
            <div className="no-permission-body">
                <h3 className="no-permission-heading">{Locale.getText('MEDIA_NO_ACCESS_TITLE')}</h3>
                <p className="no-permission-text">{Locale.getText('MEDIA_NO_ACCESS_TEXT')}</p>
            </div>
        );
    }
    if (contextError && contextError.context.includes('navtree')) {
        if (process.env.NODE_ENV !== 'test') {
            console.error('Network Timeout Error Loading NavTree: ', contextError); // eslint-disable-line
        }
        return renderWithContext(renderContextError());
    }
    if (folderData && folderData.children.length) {
        if (focused) {
            return renderWithContext(renderDetails(isTagView));
        }
        if (controllerApi.getShowGrid()) {
            return renderWithContext(renderGridView(isTagView, unselectedTagView));
        }
        return renderWithContext(renderListView(isTagView, unselectedTagView));
    }
    if (loading) {
        // this shows a loading icon for the entire page
        return renderWithContext(renderLoadingIcon());
    }
    if (contextError?.context === 'assets') {
        if (process.env.NODE_ENV !== 'test') {
            console.error('Network Timeout Error Loading Assets: ', contextError); // eslint-disable-line
        }
        return renderWithContext(renderContextError());
    }
    return null;
}

MediaLibraryView.dataForListView = payload => {
    const list = [];
    if (payload && payload.length) {
        payload.forEach(item => {
            const label = item.label ? Util.decodeLabel(item.label) : Locale.getText('NOT_FOUND');
            const type = Locale.getText(Util.getFileTypeLabelFromMimeType(item.mimeType, item));
            const dimensions = item.width && item.height ? `${item.width} x ${item.height}` : '--';
            const fileSize = item.fileSize ? Util.byteSizeString(item.fileSize, 2) : '--';
            list.push([label, type, dimensions, fileSize]);
        });
    }
    return list;
};

MediaLibraryView.allowBadge = assetFilterz => {
    return !assetFilterz || assetFilterz.length === 0 || assetFilterz.length >= 3;
};
